module.exports = __webpack_public_path__ + "img/icon-zip.bf228b01.svg";